import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin")({
  beforeLoad: ({ context }) => {
    if (context.profile.role !== "admin") throw redirect({ to: "/home" });
  },
  component: AdminHome,
});

// Staff dashboard. Registrations, players, enrollments and payments arrive in the next steps.
function AdminHome() {
  const { profile } = Route.useRouteContext();
  return (
    <section>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-a1-red">Admin</p>
      <h1 className="mt-2 font-display text-4xl font-extrabold uppercase italic">
        Hi{profile.first_name ? `, ${profile.first_name}` : ""}.
      </h1>
      <p className="mt-3 max-w-xl text-white/70">The A1 admin dashboard is being set up.</p>
    </section>
  );
}
